export default __webpack_public_path__ + "static/media/user-profile-image.5a7930c6.svg";